import { createSlice, PayloadAction, SerializedError } from "@reduxjs/toolkit";
import { CompetitionData, GetActiveCompetitionsResponse } from "../../../components/ActiveCompetitions/types";
import { setActiveCompetitions } from "./actions";

type CategoriesState = {
  categories: CompetitionCategoryResponse[];
  activeCompetitions: CompetitionData[];
  loading: boolean;
  featuredImage: string;
  errors: Record<string, SerializedError>;
};

export type CompetitionCategoryResponse = {
  type: string;
  title: string;
  subtitle: string;
  imageUrl: string;
  competitionIds: number[];
};

export type CompetitionCategory = {
  type: string;
  title: string;
  subtitle: string;
  imageUrl: string;
  competitions: CompetitionData[];
};

const INITIAL_STATE: CategoriesState = {
  categories: [],
  activeCompetitions: [],
  loading: true,
  featuredImage: "",
  errors: {},
};

export const categoriesSlice = createSlice({
  name: "competitionsCategories",
  initialState: INITIAL_STATE,
  reducers: {
    setFeaturedImage: (state, action: PayloadAction<string>) => {
      state.featuredImage = action.payload;
    },
    setActiveCompetitionsOnSync: (state, action: PayloadAction<GetActiveCompetitionsResponse>) => {
      state.loading = false;
      if (action.payload.competitions) {
        state.activeCompetitions = action.payload.competitions;
      }
      if (action.payload.categories) {
        state.categories = action.payload.categories;
      }
    },
  },
  extraReducers: builder =>
    builder
      .addCase(setActiveCompetitions.pending, (state, action) => {
        if (state.errors[action.meta.requestId]) {
          delete state.errors[action.meta.requestId];
        }
      })
      .addCase(setActiveCompetitions.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.competitions) {
          state.activeCompetitions = action.payload.competitions;
        }
        if (action.payload.categories) {
          state.categories = action.payload.categories;
        }
      })
      .addCase(setActiveCompetitions.rejected, (state, action) => {
        state.errors[action.meta.requestId] = action.error;
      }),
});

export const { setFeaturedImage, setActiveCompetitionsOnSync } = categoriesSlice.actions;
